import cloneDeepWith from 'lodash/cloneDeepWith'
import isObjectLike from 'lodash/isObjectLike'
import { type BannerLocaleEnum } from 'domains/merchandising/api'

export const removeLocaleKeys = (object: object, locale: BannerLocaleEnum) =>
  cloneDeepWith(object, value =>
    isObjectLike(value) && locale in value ? value[locale] : undefined
  )
